module.exports = __webpack_public_path__ + "img/bone-transparent-background.fc5a4f24.png";